export default __webpack_public_path__ + "static/media/gw.23954d5d.svg";